export const LAYER_LIST = {
  // 第一階層
  FIRST: 'layer1',
  // 第二階層
  SECOND: 'layer2',
  // 第三階層
  THIRD: 'layer3',
  // 第四階層
  FOURTH: 'layer4',
  // 第五階層
  FIFTH: 'layer5'
} as const;
